<template>
    <div class="login">
        <div class="colum" :style="{'width': '40%'}">
            <img src="@/assets/logo.png" class="logo" alt="">
        </div>
        <div class="colum" :style="{'width': '60%'}">
            <div class="login_container">
                <center>
                    <h3>LOGIN ADMIN</h3>
                    <label for="">Usuario</label>
                    <input type="text" v-model="email">
                    <label for="">Contraseña</label>
                    <input type="password" v-model="password" name="" id="">
                    <input type="submit" @click="login" value="Ingresar" class="send">
                </center>
            </div>
        </div>
    </div>
</template>

<script>
import API from '../api/index'

export default {
    name: 'Login',
    data() {
        return {
            email: null,
            password: null
        }
    },
    methods: {
        login: function(e) {
            e.preventDefault()
            API.Login(this.email, this.password)
                .then((response) => {
                    if (response.errors) {
                        this.errorMessage = 'Sus credenciales de inicio son incorrectas, si necesita ayuda comuníquese con soporte'
                        return false
                    }
                    return API.Me(true)
                })
                .then((redirect) => {
                    //  redirect to shop
                    if (redirect) {
                        if (this.$store.state.user.receptionist) {
                            this.$router.push('/recepcion')
                        } else {
                            this.$router.push('/')
                        }
                    }
                })
        }
    }
}
</script>

<style scoped>
    .login {
        background-color: #d1dade;
        width: 100%;
        height: 100vh;
        display: flex;
        background-attachment: fixed;
        background-repeat: no-repeat;
        background-size: 100vw;
    }
    .container {
        width: 100%;
        height: 100vh;
        display: table;
    }
    .colum{
        position: relative;
        height: 100vh;
        padding: 0;
    }
    .logo {
        width: 400px;
        height: auto;
        position: absolute;
        top: 0;
        right: -50px;
        bottom: 0;
        margin: auto;
        transform: rotate(-90deg);
    }
    .login_container {
        background-color: rgba(0, 0, 0, .7);
        -webkit-box-shadow: 5px 5px 15px 5px #000000;
        box-shadow: 5px 5px 15px 5px #000000;
        width: 500px;
        height: 500px;
        position: absolute;
        top: 0;
        left: 5px;
        bottom: 0;
        margin: auto;
    }
    .login_container > center {
        padding: 20px;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: 250px;
    }
    .login_container > center > h3 {
        color: #fff;
    }
    .login_container > center > label {
        color: #fff;
        width: 100%;
        font-size: 22px;
    }
    .login_container > center > input[type=text], input[type=password] {
        text-align: center;
        border-radius: 20px;
        height: 40px;
        width: 300px;
    }
    .login_container > center > input[type=submit] {
        width: 200px;
        height: 40px;
        border-radius: 20px;
        text-align: center;
        margin-top: 20px;
        color: #fff;
        font-size: 22;
        background-color: #e4ac5c;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue